<template>
  <div>
    <el-tabs style="position: sticky;top:0;z-index: 2;background-color: #212731" v-model="activeTab">
      <!--  -----------------------------组员列表------------------------------ -->
      <el-tab-pane name="tab1">
        <span slot="label" style="margin-left: 10px;"><i class="el-icon-user"></i>&nbsp;&nbsp;人员管理</span>
        <div>
          <el-table stripe :data="workerList">
            <el-table-column prop="id" label="ID" width="180">
              <template slot-scope="scope">
                {{scope.row.id}}
                <el-tooltip class="item" style="color: #ff4d51" effect="dark" content="账号已禁用" placement="top" v-if="!scope.row.enabled">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="username" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="score" label="绩点">
            </el-table-column>
            <el-table-column prop="appfunction" label="内部工具权限">
            </el-table-column>
            <el-table-column label="操作" width="320" align="right">
              <template slot="header" slot-scope="scope">
                <el-button type="primary" size="small" @click="onCreateWorker">新建组员</el-button>
              </template>
              <template slot-scope="scope">
                <el-button size="small" @click="onShowDetail(scope.row)">明细</el-button>
                <el-button size="small" @click="onResetPassword(scope.row)">重置密码</el-button>
                <el-button size="small" @click="onResetToolPermission(scope.row)">设置工具权限</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <!--  -----------------------------绩点模板------------------------------ -->
      <el-tab-pane name="tab2">
        <span slot="label" style="margin-left: 10px;"><i class="el-icon-coin"></i>&nbsp;&nbsp;绩点模板</span>
        <div>
          <el-table stripe :data="actionTemplateList">
            <el-table-column prop="name" label="名称" width="180">
              <template  slot-scope="scope">
                <el-tag >{{scope.row.taskType}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="工序(绩点)">
              <template  slot-scope="scope">
                <el-form :inline="true" class="demo-form-inline">
                  <el-form-item v-for = "act in scope.row.actions" :label="act.name" :key="act.name">
                    <el-input readonly :value="act.points" style="width: 70px"></el-input>
                    <el-divider direction="vertical"/>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="320" align="right">
              <template slot="header" slot-scope="scope">
                <el-button type="primary" size="small" @click="onCreateActionTemplate">新建模板</el-button>
              </template>
              <template slot-scope="scope">
                <el-button size="small" @click="onEditActionTemplate(scope.row)">编辑</el-button>
                <el-button size="small" @click="onDeleteActionTemplate(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!--  -----------------------------积分明细(抽屉)------------------------------ -->
    <el-drawer :visible.sync="detailDrawerData.show" :title="detailDrawerData.workerName" direction="rtl" customClass="detailDrawer">
      <el-table stripe :data="detailDrawerData.records" >
        <el-table-column prop="accountDate" label="时间" width="150">
        </el-table-column>
        <el-table-column prop="deltaPoints" label="增减" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.deltaPoints>0">+</span>
            {{scope.row.deltaPoints}}
          </template>
        </el-table-column>
        <el-table-column prop="points" label="余额" width="80">
        </el-table-column>
        <el-table-column prop="reason" label="原因"  align="left">
          <template slot="header" slot-scope="scope">
            <el-button plain size="small" @click="showAddRecord()">调整</el-button>
          </template>
          <template slot-scope="scope">
            {{scope.row.taskTitle}}-{{scope.row.reason}}
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
    <!--  -----------------------------新建组员(弹窗)------------------------------ -->
    <el-dialog :visible.sync="detailCreateWorker.show" :title="'[新建组员] '+this.detailCreateWorker.name" width="30%">
      <el-form label-width="80px" :model="detailCreateWorker">
        <el-form-item label="姓名">
          <el-input v-model="detailCreateWorker.name" width="100"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="detailCreateWorker.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailCreateWorker.show=false">取 消</el-button>
        <el-button type="primary" @click="doCreateWorker">确 定</el-button>
      </span>
    </el-dialog>

    <!--  -----------------------------调整绩点(弹窗)------------------------------ -->
    <el-dialog title='增减绩点 ' :visible.sync="dialogAddScorePoints.show" width="30%" center>
      <el-form label-position="left" label-width="80px">
        <el-form-item label="账号">
          <el-input v-model="dialogAddScorePoints.workerName" placeholder="" readonly></el-input>
        </el-form-item>
        <el-form-item label="增减数量">
          <el-input v-model="dialogAddScorePoints.points" placeholder="填写负数代表减"></el-input>
        </el-form-item>
        <el-form-item label="填写原因">
          <el-input v-model="dialogAddScorePoints.reason" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="权限码">
          <el-input v-model="dialogAddScorePoints.verify" placeholder="请输入权限码(非账号密码)"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddScorePoints.show = false">取 消</el-button>
        <el-button type="primary" @click="doAddScorePoints()">提 交</el-button>
      </span>
    </el-dialog>

    <!--  -----------------------------新建模板(弹窗)------------------------------ -->
    <el-dialog :visible.sync="detailCreateActionTemplate.show" :title="this.detailCreateActionTemplate.mode=='edit'?'编辑工序模板':'新建工序模板'" width="50%">
      <el-form label-width="120px" :model="detailCreateActionTemplate">
        <el-form-item label="名称">
          <el-input v-model="detailCreateActionTemplate.taskType" width="100"></el-input>
        </el-form-item>
        <el-form-item label="编辑">
          <el-input
            type="textarea"
            :rows="10"
            placeholder=""
            v-model="detailCreateActionTemplate.textarea">
          </el-input>
        </el-form-item>
        <el-form-item label="格式说明">
          <div>工序=绩点;每一行代表一个工序;范例如下:</div>
          <div>数据分期=1.05</div>
          <div>肝脏分割=2.56</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailCreateActionTemplate.show=false">取 消</el-button>
        <el-button type="primary" @click="doCommitActionTemplate">保 存</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {
  mapState
} from 'vuex';
import {isAdmin, isDoc, isAgent} from '@/utils';
import {scorepoint} from '@/api';

export default {
  name: 'AdminScorePoint',
  data() {
    return {
      activeTab: 'tab1',
      detailDrawerData: {
        show: false,
        workerName: '',
        workerId: null,
        records: [
        ]
      },
      detailCreateWorker: {
        show: false,
        name: '',
        password: ''
      },
      dialogAddScorePoints: {
        show: false,
        workerName: null,
        workerId: null,
        verify: '',
        points: 0,
        reason: '',
      },
      workerList: [
      ],
      actionTemplateList: [],
      detailCreateActionTemplate: {
        show: false,
        taskType: '',
        textarea: '',
        actions: [
        ]
      }
    };
  },
  components: {
  },
  computed: {
    ...mapState('common', ['userInfo']),
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
    isDoc() {
      const {role} = this.userInfo;
      return isDoc(role);
    },
    isAgent() {
      const {role} = this.userInfo;
      return isAgent(role);
    },
    examTitle() {
      if (this.isDoc) {
        return '诊断报告及其他';
      }
      return '诊断报告';
    },
  },
  async mounted() {
    this.onCreated();
  },
  watch: {
    '$route'() {
      this.onCreated();
    },
  },
  methods: {
    async onCreated() {
      this.fetchWorkers();
      this.fetchActionTemplates();
    },
    fetchWorkers() {
      return scorepoint.getWorkers().then(res => {
        if (res.code === 10000) {
          this.workerList = res.data;
        }
      });
    },
    fetchActionTemplates() {
      scorepoint.getActionTemplates().then(res => {
        if (res.code === 10000) {
          this.actionTemplateList = res.data.map(group => {
            return {
              taskType: group[0].taskType,
              actions: group
            };
          });
          console.log(this.actionTemplateList);
        }
      });
    },
    onCreateWorker() { // 新建组员弹窗
      this.detailCreateWorker = {
        show: true,
        name: '',
        password: ''
      };
    },
    doCreateWorker() { // 创建组员
      if (this.detailCreateWorker.name.length < 2 || this.detailCreateWorker.password.length < 3) {
        return this.$message({
          type: 'error',
          message: '请填写姓名和密码(姓名长度>=2,密码长度>=3)'
        });
      }
      scorepoint.createWorker(this.detailCreateWorker).then(res => {
        if (res.code === 10000) {
          this.detailCreateWorker.show = false;
          this.fetchWorkers();
          this.$message({
            type: 'success',
            message: '成功'
          });
        }
      });
    },
    onShowDetail(workerItem) { // 显示绩点明细
      this.detailDrawerData.show = true;
      this.detailDrawerData.records = [];
      this.detailDrawerData.workerId = workerItem.id || workerItem.workerId;
      scorepoint.getHistories(this.detailDrawerData.workerId).then(res => {
        if (res.code === 10000) {
          this.detailDrawerData.workerName = workerItem.username || workerItem.workerName;
          this.detailDrawerData.records = res.data;
          this.detailDrawerData.records.forEach(item => {
            var date = new Date(Date.parse(item.accountDate));
            item.points = Math.floor(parseFloat(item.points) * 1000.0) / 1000.0;
            item.accountDate = date.toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
          });
        }
      });
      console.log(workerItem);
    },
    showAddRecord() { // 添加绩点流水
      // this.detailDrawerData.show = false;
      this.dialogAddScorePoints.show = true;
      this.dialogAddScorePoints.workerId = this.detailDrawerData.workerId;
      this.dialogAddScorePoints.workerName = this.detailDrawerData.workerName;
      this.dialogAddScorePoints.points = '0';
      this.dialogAddScorePoints.reason = '';
      this.dialogAddScorePoints.verify = '';
    },
    doAddScorePoints() {
      if (!this.dialogAddScorePoints.points) {
        return this.$message({type: 'error', message: '请输入数量'});
      }
      if (!this.dialogAddScorePoints.reason) {
        return this.$message({type: 'error', message: '必须填写原因'});
      }
      if (!this.dialogAddScorePoints.verify) {
        return this.$message({type: 'error', message: '请输入安全密码'});
      }
      scorepoint.addRecord(this.dialogAddScorePoints).then(res => {
        if (res.code === 10000) {
          this.$message({type: 'success', message: '添加成功'});
          this.dialogAddScorePoints.show = false;
          this.fetchWorkers().then(() => {
            if (this.detailDrawerData) {
              this.onShowDetail(this.detailDrawerData);
            }
          });
        }
      });
    },
    onResetPassword(workerItem) { // 重置密码
      var cmd1 = 'cmd::deactivate';
      this.$prompt('请输入新密码,禁用账号请输入' + cmd1, workerItem.username, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        scorepoint.resetPassword({
          workername: workerItem.username,
          pass: value
        }).then(res => {
          if (res.code === 10000) {
            if (value === cmd1) {
              this.$message({
                type: 'success',
                message: '账号已停用'
              });
            } else {
              this.$message({
                type: 'success',
                message: '新密码是:' + value
              });
            }
            this.fetchWorkers();
          }
        });
      });
    },
    onResetToolPermission(workerItem) { // 设置工具权限
      this.$prompt('设置内部工具权限', workerItem.username, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: workerItem.appfunction,
      }).then(({ value }) => {
        scorepoint.setToolPermission({
          workername: workerItem.username,
          permission: value
        }).then(res => {
          if (res.code === 10000) {
            this.$message({
              type: 'success',
              message: '配置成功'
            });
            this.fetchWorkers();
          }
        });
      });
    },
    onCreateActionTemplate() { // 新建模板
      this.detailCreateActionTemplate.show = true;
      this.detailCreateActionTemplate.mode = 'new';
      this.detailCreateActionTemplate.taskType = '';
      this.detailCreateActionTemplate.textarea = '';
    },
    onEditActionTemplate(actTemplate) { // 编辑模板
      this.detailCreateActionTemplate.show = true;
      this.detailCreateActionTemplate.mode = 'edit';
      this.detailCreateActionTemplate.taskType = actTemplate.taskType;
      this.detailCreateActionTemplate.textarea = actTemplate.actions.map(act => {
        return act.name + '=' + act.points;
      }).join('\n');
    },
    doCommitActionTemplate() {
      if (this.detailCreateActionTemplate.taskType.length === 0) {
        return this.$message({type: 'error', message: '名称不能为空'});
      }
      this.detailCreateActionTemplate.actions = this.detailCreateActionTemplate.textarea.split('\n').map(line => {
        let items = line.split('=');
        if (items.length === 2) {
          return { name: items[0].trim(), points: items[1].trim() };
        }
      }).filter(action => {
        return action != null && parseFloat(action.points) > 0;
      });
      if (this.detailCreateActionTemplate.actions.length === 0) {
        return this.$message({type: 'error', message: '工序不能为空'});
      }
      scorepoint.commitActionTemplate(this.detailCreateActionTemplate.taskType, this.detailCreateActionTemplate.actions).then(res => {
        if (res.code === 10000) {
          this.$message({type: 'success', message: '保存成功!'});
          this.fetchActionTemplates();
          this.detailCreateActionTemplate.show = false;
        }
      });
    },
    onDeleteActionTemplate(actTemplate) { // 删除模板
      this.$confirm('删除模板[' + actTemplate.taskType + '], 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        scorepoint.deleteActionTemplate(actTemplate.taskType).then(res => {
          if (res.code === 10000) {
            this.$message({type: 'success', message: '删除成功!'});
            this.fetchActionTemplates();
          }
        });
      });
    }
  }
};
</script>
<style>

.detailDrawer {
  background-color: rgb(33, 39, 49);
}

</style>



// WEBPACK FOOTER //
// src/view/AdminScorePoint/index.vue